module.exports = __webpack_public_path__ + "static/media/AndrewPedersen_resume.0248c926.png";